// extracted by mini-css-extract-plugin
export default {"tag":"P_tag__VVN4Z","small":"P_small__L6Nqr","large":"P_large__sG9tp","regular":"P_regular__vJHjw","medium":"P_medium__7WNo0","semibold":"P_semibold__6qKtr"};